<template>
  <div>
    <transition name="fade" v-if="profile != null">
      <AlbumPhoto ref="album" v-show="album && profile.pictures.length >= 1" :profile="profile" />
    </transition>

    <ImageUploader
      ref="up"
      v-if="profile != null && ownProfile"
      :profile="profile"
      @onPictureUpload="pictureUploaded"
      label="Ajouter"
    />

    <div id="divProfil" v-if="profile" v-show="!loading" class="profil" :class="{ ownProfile: ownProfile }">
      <MainBox ref="mainBox" :profile="profile" :class="{ marginBandeau: $store.state.bandeau }" />

      <div class="profileBoxes" :class="{ marginBandeau: $store.state.bandeau }">
        <a v-if="ownProfile" href="#" class="disconnect" @click.prevent="disconnect">Se déconnecter</a>
        <div class="profilBox" v-if="ownProfile || shortDescription">
          <h2>Quelques mots sur {{ mle }}</h2>
          <EditableArea
            id="quelquesmots"
            :prompt="'Quelques mots sur moi...'"
            :text="shortDescription"
            @textChanged="shortChanged"
            ref="quelquesmots"
          />
        </div>
        <div class="profilBox" v-if="ownProfile || longDescription">
          <h2>Ce {{ jie }} recherche sur {{ $store.state.siteConst.name }}</h2>
          <EditableArea
            id="recherche"
            :prompt="'Ce que je recherche sur ' + $store.state.siteConst.name + '...'"
            :text="longDescription"
            @textChanged="longChanged"
            ref="jerecherche"
          />
        </div>
        <div class="profilBox infosPrincipales">
          <h2>{{ ms }}on profil</h2>
          <DataTable :indexes="mainBoxIndexes" :profile="profile" />
        </div>

        <div class="profilBox">
          <h2>{{ ms }}on style de vie</h2>
          <DataTable ref="style" :indexes="styleIndexes" :profile="profile" />
        </div>

        <div class="profilBox">
          <h2>{{ ms }}a personnalité</h2>
          <DataTable :indexes="personalityIndexes" :profile="profile" />
        </div>

        <div class="profilBox">
          <h2>{{ ms }}es convictions</h2>
          <DataTable :indexes="convictionIndexes" :profile="profile" />
        </div>

        <div :class="{ profilBox: true, hidden: !quizz }">
          <h2>{{ ms }}on quizz personnel</h2>
          <Quizz ref="quizz" :profile="profile" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { idyuJsonRpc } from "@/assets/js/idyu/connect.js";
import MainBox from "@/components/profile/MainBox";
import DataTable from "@/components/profile/DataTable";
import EditableArea from "@/components/profile/EditableArea";
import AlbumPhoto from "@/components/profile/AlbumPhoto";
import ImageUploader from "@/components/util/ImageUploader";
import BasePage from "@/components/pages/BasePage";
import Quizz from "@/components/profile/Quizz";
import Vue from "vue";

export default {
  name: "Profil",
  components: { MainBox, DataTable, AlbumPhoto, EditableArea, Quizz, ImageUploader },
  extends: BasePage,
  data() {
    return {
      profile: null,
      loadingProfile: true,
      mainBoxIndexes: [0, 34, 1, 6, 5, 7, 2, 12],
      styleIndexes: [3, 11, 13, 8, 9, 10, 4, 35],
      personalityIndexes: [18, 19, 20, 21, 22, 27, 28, 29, 30, 31, 33],
      convictionIndexes: [25, 14, 17, 23, 24, 26, 32, 15, 16, 28, 36],
      album: false,
      quizz: false,
      fromAlbum: false
    };
  },

  beforeRouteUpdate: function(_to, _from, next) {
    next();
    this.routeEnter(_to, _from);
  },

  computed: {
    ownProfile: function() {
      if (!this.$store.state.profile) {
        return false;
      }
      if (this.profile == null) {
        return false;
      }
      return this.$store.state.profile.id === this.profile.id;
    },

    ms: function() {
      if (this.ownProfile) return "M";
      return "S";
    },

    mle: function() {
      if (this.ownProfile) return "moi";
      if (this.profile.sex === "MALE") return "lui";
      return "elle";
    },

    MLE: function() {
      let str = this.mle;

      return str.charAt(0).toUpperCase() + str.slice(1);
    },

    jie: function() {
      if (this.ownProfile) return "que je";
      if (this.profile.sex === "MALE") return "qu'il";
      return "qu'elle";
    },

    shortDescription: function() {
      if (this.ownProfile && this.profile.shortDescriptionToValidate) {
        return this.profile.shortDescriptionToValidate;
      }
      return this.profile.shortDescription;
    },

    longDescription: function() {
      if (this.ownProfile && this.profile.longDescriptionToValidate) {
        return this.profile.longDescriptionToValidate;
      }
      return this.profile.longDescription;
    },

    loading: function() {
      if (this.loadingProfile) {
        return true;
      }
      return this.$store.state.loading && this.fromAlbum == false;
    }
  },

  methods: {
    routeEnter: async function(to, from) {
      const pseudo = this.$route.query.p;
      this.loadingProfile = true;

      if (to.name == "Album" || from.name == "Album") {
        this.fromAlbum = true;
      } else {
        this.fromAlbum = false;
      }

      if (!pseudo) {
        this.profile = this.$store.state.profile;
      } else {
        let result = null;
        try {
          result = await idyuJsonRpc("getProfile", pseudo);
        } catch {
          this.$router.push({ name: "ProfilSupprime" });
          this.loadingProfile = false;
          return;
        }
        this.profile = result;
        if (this.ownProfile === false) {
          idyuJsonRpc("sendVisit", this.profile.id);
        }
      }
      // This will ensure that all $refs are created
      await Vue.nextTick();

      if (to.name === "Album") {
        this.album = true;
        if (this.$refs.album) {
          this.$refs.album.init();
        }
      } else {
        this.album = false;
      }

      if (from.name === "Album" || (to.name == "Album" && from.name == "Profil")) {
        this.loadingProfile = false;
        return;
      }

      if (this.$refs.quizz) {
        this.quizz = await this.$refs.quizz.init();
      }

      if (this.$refs.mainBox) {
        this.$refs.mainBox.init();
      }

      if (this.$refs.jerecherche) {
        this.$refs.jerecherche.refresh();
      }
      if (this.$refs.quelquesmots) {
        this.$refs.quelquesmots.refresh();
      }

      this.loadingProfile = false;
    },

    shortChanged: function(val) {
      this.$store.state.profile.shortDescriptionToValidate = val;
      idyuJsonRpc("updateDescription", val, null);
      this.$store.commit("updateBandeau");
    },

    longChanged: function(val) {
      this.$store.state.profile.longDescriptionToValidate = val;
      idyuJsonRpc("updateDescription", null, val);
      this.$store.commit("updateBandeau");
    },

    pictureUploaded: async function(pic) {
      pic.className = "profile.CPicture";
      this.$store.commit("setLoading", true);
      try {
        const newPic = await idyuJsonRpc("addPicture", pic);
        this.profile.pictures.push(newPic);
        if (newPic.is_main) this.profile.mainPicture = newPic;
        await Vue.nextTick();
        this.showAlbum(newPic.id);
        this.$store.commit("updateBandeau");
      } catch (error) {
        await alert("Une erreur a eu lieu lors de l'envoi de votre photo.\n\n" + error);
      } finally {
        this.$store.commit("setLoading", false);
      }
    },

    showAlbum: function(id) {
      this.fromAlbum = true;
      if (this.profile.pictures.length >= 1) {
        this.$refs.album.selectById(id);
        this.$router.push({ name: "Album", query: this.$route.query });
      }
    },

    disconnect: async function() {
      await idyuJsonRpc("destroySession");
      localStorage.login = null;
      localStorage.password = null;
      Vue.$cookies.set("crypt", "");
      window.location = "/";
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/css/vars.scss";

#divProfil {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  top: $menu_height;
  background-color: $background_color;
  width: 100%;
  max-width: 1220px;
  margin: 0 auto;
}

.profileBoxes {
  position: absolute;
  display: grid;
  grid-template-columns: auto;
  grid-auto-rows: min-content;
  grid-gap: $content_margins $content_margins;
  left: 270px;
  right: 15px;
  bottom: 0px;
  top: 0px;
  padding-right: 10px;
  overflow-y: scroll;

  .profilBox {
    padding: 0px;
  }

  h2 {
    margin-top: 0;
    margin-bottom: 5px;
    font-size: 16px;
    margin-top: 0;
  }
}

#panelProfil {
  width: 365px;
  position: absolute;
  top: 0px;
  left: 0px;
}

.zoneTexte .descriptionArea {
  width: 452px;
  height: 181px;
  text-align: left;
  color: black;
  border: 1px solid #ddd;
  background-color: white;
  font-size: 14px;
  overflow-y: scroll;
  overflow-x: none;
  padding: 5px;
  text-align: justify;
}

.zoneTexte .descriptionArea img {
  vertical-align: middle;
}

.zoneTexte textarea {
  display: none;
}

.zoneTexte div.descriptionArea p {
  margin-top: 0px;
}

.hidden {
  display: none;
}

.disconnect {
  font-style: italic;
  text-decoration: underline;
  font-size: 14px;
  position: absolute;
  top: 0;
  right: 10px;
}

@media screen and (max-width: $app_width) {
  #divProfil {
    top: $menu_height_smallapp;
  }
}

@media screen and (max-width: 845px) {
  .profileBoxes {
    margin-left: 0;
  }

  #divProfil {
    top: $menu_height_noprogress;
  }
}

@media screen and (max-width: 700px) {
  .profileBoxes {
    grid-template-columns: auto;
  }
}

@media screen and (max-width: 550px) {
  #divProfil {
    position: unset;
  }

  .mainBox {
    position: relative;
  }

  .profileBoxes {
    position: relative;
    left: unset;
    right: unset;
  }
}
@media screen and (max-width: 580px) {
  .disconnect {
    display: none;
  }
}
</style>
